define('vspot-angular/services/charges-service',[], function () {
    'use strict';

    return ['resources.Charges', function (Charges) {
        return {
            /*
             * Create a subscription for a user
             *
             * @returns  Resource object. See /resources.js documentation for details.
             */
            createSubscription: function(postData) {
                return Charges.createSubscription(postData);
            },

            createSubscriptionNew: function(postData) {
                return Charges.createSubscriptionNew(postData);
            },

            createSubscriptionElement: function(postData) {
                return Charges.createSubscriptionElement(postData);
            },

            paymentAttemptElement: function(postData) {
                return Charges.paymentAttemptElement(postData);
            },
            invoiceFinalizeElement: function(intent) {
                return Charges.invoiceFinalizeElement({intent: intent});
            },

            /*
             * Update a subscription for a user
             *
             * @returns  Resource object. See /resources.js documentation for details.
             */
            updateSubscription: function(planId, stripeToken) {
                return Charges.updateSubscription({
                    subscription_plan_id:   planId,
                    stripeToken:            stripeToken
                });
            },
            updateSubscriptionElement: function(planId) {
                return Charges.updateSubscriptionElement({
                    subscription_plan_id:   planId
                });
            },
            accountCreateStandard: function(activityId,user_country) {
                return Charges.accountCreateStandard({
                    activity_id:    activityId,
                    user_country:   user_country
                });
            },
            disconnect: function(activityId) {
                return Charges.disconnect({
                    activity_id:    activityId
                });
            },
            salestax: function(address_line1,address_line2,address_city,address_state,address_country,address_postal_code,amount,subscription_plan_id,description) {
                return Charges.salestax({
                    address_line1:    address_line1,
                    address_line2:  address_line2,
                    address_city:   address_city,
                    address_state:  address_state,
                    address_country: address_country,
                    address_postal_code: address_postal_code,
                    amount:     amount,
                    subscription_plan_id: subscription_plan_id,
                    description: description
                });
            },
            salestaxInvoice: function() {
                return Charges.salestaxInvoice();
            },
        };
    }];
});

